<template>
  <div>
    <cabecalho-pagina
      :titulo="$t('modulos.instrumento.titulos.revisar')"
      :sem-filtro="true"
      :sem-botoes="true"
      :sem-registros="true"
    />
    <div v-if="id">
      <v-chip class="mr-1" small>
        {{ $t('modulos.instrumento.tabela.codigo') }}:
        {{ `${instrumento.codigoTag}` }}
      </v-chip>
      <v-chip class="mr-1" small>
        {{ $t('modulos.instrumento.tabela.tipo') }}:
        {{ `${instrumento.tipoInstrumento}` }}
      </v-chip>
      <v-chip class="mr-1" small>
        {{ $t('modulos.instrumento.tabela.participanteCliente') }}:
        {{ `${instrumento.participanteCliente}` }}
      </v-chip>
      <v-chip v-if="instrumento.dataAlteracao" class="mr-1" small>
        {{ $t('modulos.instrumento.tabela.data_ultima_alteracao') }}:
        {{ `${instrumento.dataAlteracao}` }}
      </v-chip>
    </div>
    <tabela-padrao-prime-vue
      ref="tabela"
      class="mt-2"
      :colunas="tabela.colunas"
      ajustar-altura-linha
      :dados="tabela.dados"
      :mostrar-acoes="false"
      :mostrar-seletor="false"
      :quantidade-itens="tabela.quantidadeItens"
      :por-pagina="tabela.porPagina"
      :pagina="tabela.paginaAtual"
      :filters="tabela.filters"
      :global-filters="tabela.colunas.map((c) => c.value)"
      paginacao-em-memoria
      sem-paginacao
      filtro-geral
    >
      <template v-slot:flagAlteradoCliente="{ slotProps }">
        <input-select
          v-if="slotProps.data.flagAlteradoCliente"
          v-model="slotProps.data.acaoUsuario"
          placeholder="Selecione"
          class="flex-fill input-tabela-analise-tecnica my-1"
          :options="opcoes.EnumSituacaoInstrumentoRevisao"
          :sem-label="true"
        />
      </template>
    </tabela-padrao-prime-vue>
    <template>
      <v-divider class="my-5" />
      <div class="d-flex align-center justify-end">
        <botao-padrao outlined color="secondary" class="mr-2" @click="cancelar">
          <v-icon>$mdiCancel</v-icon>
          {{ $t('geral.botoes.cancelar') }}
        </botao-padrao>
        <botao-padrao @click="salvar">
          <v-icon>$mdiContentSaveOutline</v-icon>
          {{ $t('geral.botoes.salvar') }}
        </botao-padrao>
      </div>
    </template>
  </div>
</template>
<script>
import CabecalhoPagina from '@/components/layout/CabecalhoPagina.vue';
import InstrumentoService from '@common/services/cadastros/InstrumentoService.js';
import EnumeradorService from '@common/services/cadastros/EnumeradorService';
import { FilterMatchMode } from 'primevue/api';
import helpers from '@common/utils/helpers';
import _ from 'lodash';

export default {
  name: 'RevisarInstrumento',
  components: {
    CabecalhoPagina,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      instrumento: {
        codigoTag: null,
        tipoInstrumento: null,
        participanteCliente: null,
        dataAlteracao: null,
      },
      opcoes: {
        EnumSituacaoInstrumentoRevisao: [],
      },
      tabela: {
        dados: [],
        colunas: [
          {
            value: 'informacao',
            text: this.$t('modulos.instrumento.revisar_instrumento.informacao'),
            sortable: false,
          },
          {
            value: 'informacaoCadastrada',
            text: this.$t(
              'modulos.instrumento.revisar_instrumento.informacaoCadastrada'
            ),
            sortable: false,
            formatter: (v) => {
              if (v == 'True') {
                return this.$t('enums.boleano.sim');
              }
              if (v == 'False') {
                return this.$t('enums.boleano.nao');
              } else return v;
            },
          },
          {
            value: 'informacaoAlteradaPeloCliente',
            text: this.$t(
              'modulos.instrumento.revisar_instrumento.informacaoAlteradaCliente'
            ),
            sortable: false,
            formatter: (v) => {
              if (v == 'True') {
                return this.$t('enums.boleano.sim');
              }
              if (v == 'False') {
                return this.$t('enums.boleano.nao');
              } else return v;
            },
          },
          {
            value: 'flagAlteradoCliente',
            text: this.$t(
              'modulos.instrumento.revisar_instrumento.acaoAlteracaoCliente'
            ),
            sortable: false,
            formatter: (v) => {
              if (!v) {
                return this.$t(
                  'modulos.instrumento.revisar_instrumento.naoFoiAlterado'
                );
              }
            },
          },
        ],
        quantidadeItens: 0,
        quantidadePaginas: 0,
        paginaAtual: 1,
        porPagina: 10,
        filters: {
          global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        },
      },
    };
  },
  async mounted() {
    this.listarRegistros();
    this.buscarDadosInstrumento();
    await this.buscarEnumSituacaoInstrumentoRevisao();
  },
  methods: {
    listarRegistros: function () {
      let parametros = {
        page: 1,
        amountPerPage: 1000,
      };
      this.$store.dispatch('Layout/iniciarCarregamento');
      return InstrumentoService.buscarDadosRevisar(this.id, parametros)
        .then((res) => {
          const dados = _.cloneDeep(res.data.items);
          dados.forEach((dado) => (dado.acaoUsuario = null));
          this.tabela.dados = dados;
          this.tabela.quantidadeItens = this.tabela.dados.length;
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    buscarDadosInstrumento: function () {
      this.$store.dispatch('Layout/iniciarCarregamento');
      return InstrumentoService.buscar(this.id)
        .then((res) => {
          this.instrumento.codigoTag = res.data.codigoTag;
          this.instrumento.tipoInstrumento = res.data.tipoInstrumento.nome;
          this.instrumento.participanteCliente =
            res.data.participanteCliente.nome;
          this.instrumento.dataAlteracao = helpers.formatarDataBr(
            res.data.dataAlteracao,
            true
          );
        })
        .finally(() => {
          this.$store.dispatch('Layout/terminarCarregamento');
        });
    },
    buscarEnumSituacaoInstrumentoRevisao: async function () {
      await EnumeradorService.buscar('EnumSituacaoInstrumentoRevisao').then(
        (res) => {
          this.opcoes.EnumSituacaoInstrumentoRevisao = res;
        }
      );
    },
    cancelar: function () {
      this.confirmarCancelar().then(() => {
        this.$router.push({ name: 'instrumento' });
      });
    },
    salvar: function () {
      const camposNaoSelecionados = this.tabela.dados.some(
        (dado) => dado.flagAlteradoCliente && !dado.acaoUsuario
      );

      if (camposNaoSelecionados) {
        this.toastAlerta(
          this.$t('modulos.instrumento.validacoes.selecionar_opcao_revisao')
        );
        return;
      }

      this.confirmar(
        this.$t('modulos.instrumento.revisar_instrumento.confirmar_revisao')
      ).then(() => {
        this.$store.dispatch('Layout/iniciarCarregamento');
        const dadosTabela = _.cloneDeep(this.tabela.dados);
        const dadosAprovados = dadosTabela.filter(
          (dado) => dado.acaoUsuario === 'Aprovado'
        );
        dadosAprovados.forEach(
          (dado) => (dado.flagAlteradoCliente = dado.acaoUsuario)
        );
        return InstrumentoService.atualizarRevisao(this.id, dadosAprovados)
          .then(() => {
            this.$router.push({ name: 'instrumento' });
            this.toastSucesso(this.$t(`modulos.instrumento.revisao_sucesso`));
          })
          .catch((err) => {
            this.toastErro(
              this.$t(`geral.erros.${err.response.data.errors[0]}`)
            );
          })
          .finally(() => {
            this.$store.dispatch('Layout/terminarCarregamento');
          });
      });
    },
  },
};
</script>
